export function PythonIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="56" 
        height="56" 
        viewBox="0 0 56 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M22.0332 0C17.6389 0 14.0767 3.44907 14.0767 7.70372V13.0371H27.8475V14.5186H7.95642C3.5622 14.5186 0 17.9676 0 22.2223V33.7779C0 38.0325 3.5622 41.4815 7.95642 41.4815H12.5467V34.9631C12.5467 30.7085 16.1089 27.2593 20.5032 27.2593H35.1918C38.9101 27.2593 41.9241 24.3409 41.9241 20.7409V7.70372C41.9241 3.44907 38.3621 0 33.9678 0H22.0332ZM20.1972 9.4815C21.7182 9.4815 22.9512 8.28758 22.9512 6.81484C22.9512 5.34207 21.7182 4.14815 20.1972 4.14815C18.6759 4.14815 17.4429 5.34207 17.4429 6.81484C17.4429 8.28758 18.6759 9.4815 20.1972 9.4815Z" 
          fill="url(#paint0_linear_python)" 
        />
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M33.9667 56.0001C38.3609 56.0001 41.9232 52.5511 41.9232 48.2965V42.9631H28.1524V41.4817H48.0435C52.4378 41.4817 55.9998 38.0324 55.9998 33.7778V22.2222C55.9998 17.9676 52.4378 14.5186 48.0435 14.5186H43.4532V21.037C43.4532 25.2918 39.891 28.7408 35.4969 28.7408H20.808C17.0898 28.7408 14.0757 31.6592 14.0757 35.2592V48.2965C14.0757 52.5511 17.638 56.0001 22.032 56.0001H33.9667ZM35.8029 46.5187C34.2817 46.5187 33.0486 47.7125 33.0486 49.1853C33.0486 50.6581 34.2817 51.8519 35.8029 51.8519C37.3239 51.8519 38.5569 50.6581 38.5569 49.1853C38.5569 47.7125 37.3239 46.5187 35.8029 46.5187Z" 
          fill="url(#paint1_linear_python)" 
        />
        <defs>
          <linearGradient 
            id="paint0_linear_python" 
            x1="20.9622" 
            y1="0" 
            x2="20.9622" 
            y2="41.4815" 
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#327EBD"/>
            <stop offset="1" stopColor="#1565A7"/>
          </linearGradient>
          <linearGradient 
            id="paint1_linear_python" 
            x1="35.0379" 
            y1="14.5186" 
            x2="35.0379" 
            y2="56.0001" 
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFDA4B"/>
            <stop offset="1" stopColor="#F9C600"/>
          </linearGradient>
        </defs>
      </svg>
    )
  }